export const SDK_SETTINGS = {
  apiPath: 'api',
  proxyPath: 'proxy',
  staticPath: 'files',
  storedenPath: 'storeden/v1.1',
}
